import React, { useState, useEffect } from 'react';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import Breadcrumbs from '../../components/common/Breadcrumbs/Breadcrumbs';
import Search from '../../components/common/Search/Search';
import NewsCard from '../../components/News/NewsCard';
import './NewsPage.css';
import { newsService } from '../../services/newsService';

const NewsPage = () => {
  const [news, setNews] = useState([]);
  const [filteredNews, setFilteredNews] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const data = await newsService.getNews();
        setNews(data.news);
        setFilteredNews(data.news);
      } catch (error) {
        console.error('Ошибка загрузки новостей:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  const breadcrumbsItems = [
    { path: '/', label: 'Главная' },
    { path: '/news', label: 'Новости' }
  ];

  const handleSearch = (query) => {
    setSearchQuery(query);
    if (query.trim() === '') {
      setFilteredNews(news);
    } else {
      const filtered = news.filter(item =>
        item.title.toLowerCase().includes(query.toLowerCase()) ||
        item.description.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredNews(filtered);
    }
  };

  if (loading) {
    return (
      <div className="news-page">
        <Header />
        <main className="news-page-content">
          <div className="loader-container">
            <div className="loader"></div>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="news-page">
      <Header />
      <main className="news-page-content">
        <div className="news-page-top-section">
          <div className="breadcrumbs-and-search">
            <Breadcrumbs items={breadcrumbsItems} />
            <div className="search-wrapper">
              <Search
                placeholder="Поиск новостей..."
                onSearch={handleSearch}
              />
            </div>
          </div>
        </div>
        <div className="news-grid-container">
          {filteredNews.length > 0 ? (
            <div className="news-page-grid">
              {filteredNews.map((newsItem) => (
                <NewsCard
                  key={newsItem.id}
                  id={newsItem.id}
                  title={newsItem.title}
                  description={newsItem.description}
                  image={newsItem.image}
                  date={new Date(newsItem.date).toLocaleDateString('ru-RU', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric'
                  })}
                  className="news-page-card"
                />
              ))}
            </div>
          ) : (
            <div className="no-results">
              <p className="no-results-text">По запросу "{searchQuery}" ничего не найдено</p>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NewsPage;